import { DownloadOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

const I18N_BASE = 'scenes.visit_history.header';

interface VisitHistoryHeaderProps {
  /** Data is loaded and there is at least one stop. */
  canDownload: boolean;
  exporting: boolean;
  onDownload: () => void;
}

/** Title, one-line subtitle and the export action. */
function VisitHistoryHeader({
  canDownload,
  exporting,
  onDownload,
}: VisitHistoryHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="visit-history-header">
      <div>
        <h1 className="visit-history-header__title">
          {t(`${I18N_BASE}.title`)}
        </h1>
        <p className="visit-history-header__subtitle">
          {t(`${I18N_BASE}.subtitle`)}
        </p>
      </div>

      {/* The span lets the tooltip show over a disabled button. */}
      <Tooltip
        title={canDownload ? undefined : t(`${I18N_BASE}.download_disabled`)}
      >
        <span>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            disabled={!canDownload}
            loading={exporting}
            onClick={onDownload}
          >
            {t(`${I18N_BASE}.download`)}
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}

export default VisitHistoryHeader;
